var render, staticRenderFns
import script from "./pc-form-renderer.vue?vue&type=script&lang=ts&"
export * from "./pc-form-renderer.vue?vue&type=script&lang=ts&"
import style0 from "./pc-form-renderer.vue?vue&type=style&index=0&id=c7b8bfcc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b8bfcc",
  null
  
)

export default component.exports